import { useEffect } from "react";
import { useSelector } from "react-redux";
import { notificationSoundManager } from "../../../utils/notificationSoundManager";
import { customerFullName } from "../../../../util/utils";

const getPlatformNotificationsConfig = (retailerUser, platform) => {
  if (!retailerUser || !platform) return null;
  const payload = retailerUser.notifications_payload || retailerUser.notificationsPayload;
  return payload?.[platform] ?? null;
};

export default function useInboxNotifications() {
  // Current Retailer User
  const currentRetailerUser = useSelector((state) => state.retailerUsersReducer.currentRetailerUser);

  // If already in the chat, no sound
  const selectedId = useSelector((state) => state.conversationsReducer.selectedConversationId);

  useEffect(() => {
    const handler = (event) => {
      const data = event.detail;

      if (!data) return;
      if (String(data?.chat?.id) === String(selectedId)) return;

      const platform = data?.chat?.type;
      const platformNotificationsConfig = getPlatformNotificationsConfig(currentRetailerUser, platform);

      if (platformNotificationsConfig?.silenced === true) {
        return;
      }

      const sound = platformNotificationsConfig?.sound
        ? `/sounds/${platformNotificationsConfig.sound}`
        : "/sounds/notification_tune.mp3";

      notificationSoundManager.play(sound);

      if (Notification.permission === "granted") {
        const fullName = customerFullName(data?.chat?.attributes, currentRetailerUser);
        try {
          const notification = new Notification(fullName, {
            body: (
              data?.message?.content_text
              || data?.message?.content_media_caption
              || data?.message?.content_type
            )?.substring(0, 75),
            icon: "/logo.png",
            tag: `chat-${data?.message?.id}`,
            renotify: true,
            requireInteraction: false,
            data: {
              conversationId: data?.chat?.id
            }
          });

          notification.onclick = () => {
            window.focus();
            notification.close();

            // optional: open conversation
            window.dispatchEvent(
              new CustomEvent("inbox:open-conversation", {
                detail: {
                  conversationId: data?.chat?.id,
                  platform: data?.chat?.type,
                  customerId: data?.chat?.attributes?.customer_id
                }
              })
            );
          };
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("Error showing notification:", error);
        }
      }
    };

    window.addEventListener("inbox:new-message", handler);

    return () => {
      window.removeEventListener("inbox:new-message", handler);
    };
  }, [currentRetailerUser, selectedId]);
}
